import React from "react";

const ProductImage = (props) => {
  const {image, className = "", style} = props;

  return <img
    src={image}
    className={`full-width ${className}`}
    style={{...style}}
  />;
};

export default ProductImage;
